// extracted by mini-css-extract-plugin
export default {"updateBtn":"NewUser_updateBtn__T+T+O"};